import React from 'react';
import Moo from '../../../assets/TrustedInsurers/MutualofOmaha.svg';
import MooPng from '../../../assets/TrustedInsurers/MutualofOmaha.png';
import Aetna from '../../../assets/TrustedInsurers/Aetna.svg';
import AetnaPng from '../../../assets/TrustedInsurers/Aetna.png';
import Aig from '../../../assets/TrustedInsurers/AIG.svg';
import AigPng from '../../../assets/TrustedInsurers/AIG.png';
import './TrustedInsurers.css';
import { isMacOS } from '../../../utils/isMacOS';
import { isFirefox } from '../../../utils/isFirefox';
import { useTheme } from '../../../context/ThemeContext';
import PhysiciansMutual from '../../../assets/TrustedInsurers/Physicians Mutual.svg';
import PhysiciansMutualPng from '../../../assets/TrustedInsurers/Physicians Mutual.png';
import AAA from '../../../assets/TrustedInsurers/AAA.svg';
import AAApng from '../../../assets/TrustedInsurers/AAA.png';
import ColonialPenn from '../../../assets/TrustedInsurers/ColonialPenn.svg';
import ColonialPennPng from '../../../assets/TrustedInsurers/ColonialPenn.png';
import StateFarm from '../../../assets/TrustedInsurers/State Farm.svg';
import StateFarmPng from '../../../assets/TrustedInsurers/State Farm.png';
import USAA from '../../../assets/TrustedInsurers/USAA.svg';
import USAAPng from '../../../assets/TrustedInsurers/USAA.png';
import AARP from '../../../assets/TrustedInsurers/AARP.svg';
import AARPPng from '../../../assets/TrustedInsurers/AARP.png';
import Trustage from '../../../assets/TrustedInsurers/Trustage.svg';
import TrustagePng from '../../../assets/TrustedInsurers/Trustage.png';
import Aflac from '../../../assets/TrustedInsurers/Aflac.svg';
import AflacPng from '../../../assets/TrustedInsurers/Aflac.png';
import LincolnHeritage from '../../../assets/TrustedInsurers/LincolnHeritage.svg';
import LincolnHeritagePng from '../../../assets/TrustedInsurers/LincolnHeritage.png';
import PhysiciansMutualDark from '../../../assets/TrustedInsurers/DarkTheme/Physicians Mutual dark.svg';
import AAADark from '../../../assets/TrustedInsurers/DarkTheme/AAA dark.svg';
import MooDark from '../../../assets/TrustedInsurers/DarkTheme/MutualofOmaha dark.svg';
import ColonialPennDark from '../../../assets/TrustedInsurers/DarkTheme/ColonialPenn dark.svg';
import StateFarmDark from '../../../assets/TrustedInsurers/DarkTheme/State Farm dark.svg';
import USAADark from '../../../assets/TrustedInsurers/DarkTheme/USAA dark.svg';
import AetnaDark from '../../../assets/TrustedInsurers/DarkTheme/Aetna dark.svg';
import AARPDark from '../../../assets/TrustedInsurers/DarkTheme/AARP dark.svg';
import TrustageDark from '../../../assets/TrustedInsurers/DarkTheme/Trustage dark.svg';
import LincolnHeritageDark from '../../../assets/TrustedInsurers/DarkTheme/Lincoln Heritage dark.svg';
import AigDark from '../../../assets/TrustedInsurers/DarkTheme/AIG dark.svg';
import AflacDark from '../../../assets/TrustedInsurers/DarkTheme/Aflac dark.svg';

const TrustedInsurers = props => {
  const { theme } = useTheme();
  const isDark = theme === 'dark';
  const usePng = !isMacOS() && isFirefox() && !isDark;
  const isChatGptDerivedUser = props.chatGptDerived === 'true';
  const normalizedCoverage = Number(String(props.coverage || '').replace(/[^\d]/g, ''));
  const showFinalExpenseCopy = isChatGptDerivedUser && normalizedCoverage > 50000;
  const introText = showFinalExpenseCopy
    ? 'Choice Mutual lets you compare final expense insurance prices from over 25 insurers, including:'
    : 'You’re about to compare life & final expense insurance quotes from over 25 insurers, including:';

  const physiciansMutualSrc = isDark ? PhysiciansMutualDark : (usePng ? PhysiciansMutualPng : PhysiciansMutual);
  const aaaSrc = isDark ? AAADark : (usePng ? AAApng : AAA);
  const mooSrc = isDark ? MooDark : (usePng ? MooPng : Moo);
  const colonialPennSrc = isDark ? ColonialPennDark : (usePng ? ColonialPennPng : ColonialPenn);
  const stateFarmSrc = isDark ? StateFarmDark : (usePng ? StateFarmPng : StateFarm);
  const usaaSrc = isDark ? USAADark : (usePng ? USAAPng : USAA);
  const aetnaSrc = isDark ? AetnaDark : (usePng ? AetnaPng : Aetna);
  const aarpSrc = isDark ? AARPDark : (usePng ? AARPPng : AARP);
  const trustageSrc = isDark ? TrustageDark : (usePng ? TrustagePng : Trustage);
  const aflacSrc = isDark ? AflacDark : (usePng ? AflacPng : Aflac);
  const lincolnHeritageSrc = isDark ? LincolnHeritageDark : (usePng ? LincolnHeritagePng : LincolnHeritage);
  const aigSrc = isDark ? AigDark : (usePng ? AigPng : Aig);

  return ( 
    <div className="d-block quoting-logos-mobile">
        <div className="text-center max-400 mx-auto">
          {introText}
        </div>
        <div className="row align-items-center mt-3 mt-md-3 px-sm-3 first-row max-400">
            <div className="mb-4 mb-md-3 col-md-3 col-4">
              <img src={physiciansMutualSrc} alt="Physicians Mutual" />
            </div>
            <div className="mb-4 d-flex justify-content-center mb-2 mb-md-3 col-md-3 col-4">
              <img src={aaaSrc} className="AAA" alt="AAA" />
            </div>
             <div className="mb-4 mb-md-3 col-md-3 col-4 text-center">
               <img src={mooSrc} alt="Mutual of Omaha" />
            </div>
            <div className="mb-4 col-md-3 col-4">
              <img src={colonialPennSrc} className="CP" alt="Colonial Penn" />
            </div>
            <div className="mb-4  mb-md-4 col-md-3 col-4">
              <img src={stateFarmSrc} alt="State Farm" />
            </div>
            <div className="mb-4  mb-md-4 col-md-3 col-4 d-flex justify-content-center">
              <img src={usaaSrc} className="USAA" alt="USAA" />
            </div>
            <div className="mb-4  mb-md-4 col-md-3 col-4 text-center">
              <img src={aetnaSrc} className="AetnaTI" alt="Aetna" />
            </div>
            <div className="mb-4 mb-md-4 d-sm-block col-md-3 col-4">
              <img src={aarpSrc} className="AARP" alt="AARP" />
            </div>
            <div className="mb-4  mb-md-3 col-md-3 col-4">
              <img src={trustageSrc} alt="Trustage" />
            </div>
            <div className="mb-4  mb-md-3 col-md-3 col-4 d-flex justify-content-center">
              <img src={aflacSrc} className="Aflac" alt="Aflac" />
            </div>
            <div className="mb-4  mb-md-3 col-md-3 col-4 text-center">
              <img src={lincolnHeritageSrc} alt="Lincoln Heritage" />
            </div>
            <div className="mb-4 mb-md-3 col-md-3 col-4 d-flex justify-content-center">
              <img src={aigSrc} className="AIGTrustedInsurers" alt="AIG" />
            </div>
        </div>
    </div>
  );
};

export default TrustedInsurers;